(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-grid/assets/javascripts/casino-grid-virtualized.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-grid/assets/javascripts/casino-grid-virtualized.js');

'use strict';

const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["tabIndex"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const _ReactVirtuoso = ReactVirtuoso,
  VirtuosoGrid = _ReactVirtuoso.VirtuosoGrid;
const _React = React,
  forwardRef = _React.forwardRef,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const CasinoGameCard = svs.components.casino_react.casinoGameCard.CasinoGameCard;
const CasinoProviderCard = svs.components.casino_react.casinoProviderCard.CasinoProviderCard;
const CasinoCategoryCard = svs.components.casino_react.casinoCategoryCard.CasinoCategoryCard;
const CasinoGridSkeleton = svs.components.casino_react.CasinoGridSkeleton;
const _svs$components$casin = svs.components.casino_react.common.constants,
  CardType = _svs$components$casin.CardType,
  GridDisplayModes = _svs$components$casin.GridDisplayModes,
  GridRulesets = _svs$components$casin.GridRulesets,
  DefaultNumberOfCasinoGridItems = _svs$components$casin.DefaultNumberOfCasinoGridItems;
const _svs$components$casin2 = svs.components.casino_react.hooks,
  useMaxGridItems = _svs$components$casin2.useMaxGridItems,
  useSearchParams = _svs$components$casin2.useSearchParams;
const getItemCount = _ref => {
  let maxItems = _ref.maxItems,
    preferredNumberOfItems = _ref.preferredNumberOfItems;
  return Math.min(maxItems, preferredNumberOfItems);
};
const approximateCardHeight = 300;
const createGridComponents = () => ({
  List: forwardRef((_ref2, ref) => {
    let children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);
    return React.createElement("ul", _extends({
      ref: ref
    }, props), children);
  }),
  Item: forwardRef((_ref3, ref) => {
    let children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded2);
    return React.createElement("li", _extends({
      ref: ref
    }, props), children);
  }),
  Scroller: forwardRef((_ref4, ref) => {
    let children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded3);
    const tabIndex = props.tabIndex,
      restProps = _objectWithoutProperties(props, _excluded4);
    return React.createElement("div", _extends({
      ref: ref
    }, restProps), children);
  })
});
const CasinoGridVirtualized = _ref5 => {
  let displayMode = _ref5.displayMode,
    items = _ref5.items,
    fetchMore = _ref5.fetchMore,
    isLoading = _ref5.isLoading,
    totalGamesCount = _ref5.totalGamesCount;
  const ruleset = GridRulesets[displayMode];
  const itemsToRender = useMaxGridItems(items, ruleset);
  const _useSearchParams = useSearchParams(),
    queryString = _useSearchParams.q,
    tags = _useSearchParams.tags,
    decodedProviders = _useSearchParams.providers,
    listIds = _useSearchParams.listIds,
    categories = _useSearchParams.categories,
    sorting = _useSearchParams.sorting;
  const providers = decodedProviders === null || decodedProviders === void 0 ? void 0 : decodedProviders.map(encodeURIComponent);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isListVisible = _useState2[0],
    setIsListVisible = _useState2[1];
  const paginationState = useRef({
    offset: 0,
    hasPendingFetch: false,
    isNewQuery: false
  });
  const gridComponents = useMemo(() => createGridComponents(), []);
  const randomGridIdSelector = Math 
  .random().toString(16).slice(2);
  const gridKey = useMemo(() => {
    const tagsString = Array.isArray(tags) ? tags.join(',') : '';
    const providerString = Array.isArray(providers) ? providers.join(',') : '';
    const categoriesString = Array.isArray(categories) ? categories.join(',') : '';
    const listIdsString = Array.isArray(listIds) ? listIds.join(',') : '';
    return "".concat(queryString || 'empty', "-").concat(tagsString, "-").concat(providerString, "-").concat(categoriesString, "-").concat(listIdsString, "-").concat(sorting);
  }, [tags, providers, categories, listIds, queryString, sorting]);
  const oldQuery = useRef(gridKey);
  const intersectionCallback = useCallback(entries => {
    entries.forEach(entry => {
      setIsListVisible(entry.isIntersecting);
    });
  }, []);
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };
    const observer = new IntersectionObserver(intersectionCallback, options);
    const gridElement = document.querySelector(".casino-grid-virtualized-".concat(randomGridIdSelector));
    if (gridElement) {
      observer.observe(gridElement);
    }
    return () => {
      if (gridElement) {
        observer.unobserve(gridElement);
      }
    };
  }, [intersectionCallback, randomGridIdSelector]);

  useEffect(() => {
    const existMoreGamesToLoad = paginationState.current.offset < totalGamesCount;
    if (isListVisible && existMoreGamesToLoad && paginationState.current.hasPendingFetch) {
      fetchMore(paginationState.current.offset, DefaultNumberOfCasinoGridItems * 3);
      paginationState.current.hasPendingFetch = false;
    }
  }, [isListVisible, fetchMore, totalGamesCount]);
  useEffect(() => {
    if (oldQuery.current !== gridKey) {
      paginationState.current.isNewQuery = true;
    }
  }, [gridKey]);

  if (isLoading && paginationState.current.isNewQuery) {
    return React.createElement(CasinoGridSkeleton, {
      displayMode: displayMode
    });
  }
  return React.createElement(VirtuosoGrid, {
    className: "casino-grid-virtualized casino-grid-virtualized-".concat(randomGridIdSelector),
    components: gridComponents,
    endReached: endIndex => {
      const newOffset = endIndex + 1;
      const existMoreGamesToLoad = newOffset < totalGamesCount;
      if (!existMoreGamesToLoad) {
        return;
      }
      paginationState.current.isNewQuery = false;
      paginationState.current.offset = newOffset;
      if (isListVisible) {
        fetchMore(newOffset, DefaultNumberOfCasinoGridItems * 3);
        oldQuery.current = gridKey;
      } else {
        paginationState.current.hasPendingFetch = true;
      }
    },
    initialItemCount: getItemCount({
      maxItems: itemsToRender.length,
      preferredNumberOfItems: DefaultNumberOfCasinoGridItems * 2
    }),
    itemClassName: "casino-grid__item ".concat(ruleset.childClassList.join(' ')),
    itemContent: index => {
      const item = itemsToRender[index];
      return React.createElement(React.Fragment, null, item.type === CardType.GAME && React.createElement(CasinoGameCard, _extends({
        gameName: item.model.name
      }, ruleset.cardComponentProps)), item.type === CardType.PROVIDER && React.createElement(CasinoProviderCard, {
        providerName: item.model.systemName
      }), item.type === CardType.CATEGORY && React.createElement(CasinoCategoryCard, {
        categoryName: item.model.systemName
      }));
    },
    key: gridKey,
    listClassName: "casino-grid",
    overscan: approximateCardHeight * 6 
    ,
    totalCount: itemsToRender.length,
    useWindowScroll: true
  });
};
setGlobal('svs.components.casino_react.CasinoGridVirtualized', CasinoGridVirtualized);

 })(window);